import React, { useEffect, useState } from "react";
import { Menu, MenuButton, MenuItem, MenuItems, } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import CompanyLogo from "../../../common/CompanyLogo";
import { useLocation } from "react-router-dom";
import { Applyfranchisor, BASE_URL, CATEGORY } from "../../../api/endpoints";
import Api_Instance from "../../../api/Api_Instance";
import CountriesApi from "../../../common/countriesapi/CountriesApi";
import toast from "react-hot-toast";
import ErrorMessage from "../../../common/errormsg/ErrorMessage";
import { INVESTMENT_RANGE } from "../../../utils/Utils";
import parse from "html-react-parser";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { IoHeart, IoShareSocialOutline } from "react-icons/io5";
import Recentsection from "../../recentsection/Recentsection";
import { useSelector } from "react-redux";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function Automotivedetails() {
  const Location = useLocation();
  const api = Api_Instance.useApi();
  const { useCountries, States, Ctiy } = CountriesApi;
  const [errors, setErrors] = useState({});
  const [categorydata, setCategoryData] = useState([]);
  const item = Location?.state?.item;
  const recentData = Location?.state?.data;
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);
  const intialValues = {
    name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
    investment: "",
    franchise: item?.id,
    terms_conditions  : false,
    loan: "",
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
    investment: "",
    franchise: item?.id,
    terms_conditions  : false,
    loan: "",
  });
   console.log(formData,'formDatadfsf')
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldError = validate({ [name]: value })[name];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };
  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormData((prevValues) => ({
      ...prevValues,
      country: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };

  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormData((prevValues) => ({
      ...prevValues,
      state: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationErrors = validate(formData);
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        const res = await api("POST", Applyfranchisor.POST_APPLY, formData);
        if (res.status) {
          toast.success(res.data.message || "Successfully Create");
          setFormData(intialValues);
        }
      }
    } catch (error) {
      if (error?.response?.data?.code === "token_not_valid") {
        toast.error("Session expired please login again");
      } else if (
        error?.response?.data?.detail ===
        "Authentication credentials were not provided."
      ) {
        toast.error("please login you are not authorized");
      } else {
        toast.error(error.message || "invalid data");
      }
    }
  };
  const cateGoryApi = async () => {
    try {
      const res = await api("GET", CATEGORY.GET_CATEGORY);
      setCategoryData(res?.data?.data);
    } catch (error) { }
  };
  useEffect(() => {
    cateGoryApi();
  }, []);
  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "name",
      "email",
      "phone",
      "email",
      "country",
      "country",
      "state",
      "city",
      "pincode",
      "address",
      "investment",
      "loan",
    ];

    requiredFields.forEach((field) => {
      const value = values[field];

      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        errors[field] = `${field.replace(/_/g, " ")} is required`;
      }
    });

    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email address is invalid";
    }
    if (values.phone && !/^\d{10}$/.test(values.phone)) {
      errors.phone = "phone No is invalid";
    }
     
    if(!formData?.terms_conditions){
      errors.terms_conditions ="Please agree to the Terms & Conditions."

    }
    return errors;
  };
  const [activeTab, setActiveTab] = useState('About'); // Default active tab

  // Tab change handler
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  // TabPanel component to show/hide based on active tab
  const TabPanel = ({ activeTab, tab, children }) => {
    return (
      <div
        className={`rounded-lg bg-gray-50 dark:bg-gray-800 ${activeTab === tab ? 'block' : 'hidden'
          }`}
        role="tabpanel"
        aria-labelledby={`${tab}-tab`}
      >
        {children}
      </div>
    );
  };
  return (
    <>
      <div className="bg-white">
        <CompanyLogo
          title={item?.brand_name}
          // way={item?.section[0]}
          subtitle={item?.brand_name}
        />
        <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
          <div className=" flex md:flex-row flex-col ">
            <div className="flex flex-col items-center md:flex-row sm:flex-row w-full xl:mx-auto gap-4 py-2">
              <div className="border border-subtext_color max-w-[120px] min-w-[120px] h-[80px] p-2 ">
                <img
                  src={`${item?.upload_logo}`}
                  alt="img"
                  className="object-fill min-w-[100px] h-[60px]"
                />
              </div>
              <p className="text-[#4A5661] text-[24px] font-medium">
                {item?.brand_name}
              </p>
            </div>

          </div>
          <div className="relative">
            <div className="flex flex-col md:flex-row gap-4 overflow-y-auto overflow-x-hidden">
              <div className="flex flex-col items-start 2xl:w-[70%] xl:w-[70%] lg:w-[70%] w-[100%] h-[80%] ">
                <div className="bg-card_bg_color p-4 rounded-lg border h-[400px] lg:h-[600px] w-[100%] mb-4">
 
                    <img
                      src={`${item?.upload_banner}`}
                      alt="upload logo"
                      className="h-[100%] w-[100%] object"
                    />
  
                </div>
                <div className="!bg-[#FAFAFA] flex flex-wrap w-[100%] justify-around rounded p-3">

                  <div className="p-2 text-center border-b sm:border-r border-[#D9D9D9] w-[100%] sm:w-[50%] md:w-[25%] md:border-b-0">
                      <p className="text-[#4A5661] font-medium text-center text-[14px] lg:text-[16px] mx-auto w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mb-1">{item?.investment}</p>
                      <p className="text-[#5D6C72] w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mx-auto text-[14px] lg:text-[16px]">Investment Size</p>
                  </div>
                  <div className="p-2 text-center border-[#D9D9D9] w-[100%] sm:w-[50%] border-b md:w-[25%] md:border-r md:border-b-0">
                      <p className="text-[#4A5661] font-medium text-center  text-[14px] lg:text-[16px] mx-auto w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mb-1">500 - 2000 Sq.ft</p>
                      <p className="text-[#5D6C72] w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mx-auto text-[14px] lg:text-[16px]">Area Req.</p>
                  </div>
                  <div className="p-2 text-center sm:border-r border-[#D9D9D9] w-[100%] sm:w-[50%] md:w-[25%] ">
                      <p className="text-[#4A5661] font-medium text-center  text-[14px] lg:text-[16px] mx-auto w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mb-1">{item?.franchise_model}</p>
                      <p className="text-[#5D6C72] w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mx-auto text-[14px] lg:text-[16px]">Franchise Model</p>
                  </div>
                  <div className="p-2 w-[100%] border-t border-[#D9D9D9] sm:border-t-0 sm:w-[50%] text-center md:w-[25%] ">
                      <p className="text-[#4A5661] font-medium text-center  text-[14px] lg:text-[16px] mx-auto w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mb-1">{item?.brand_outlet}</p>
                      <p className="text-[#5D6C72] w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap mx-auto text-[14px] lg:text-[16px]">Franchise Outlets</p>
                  </div>
                </div>

                <div className="mb-4 w-full">
                  <ul
                    className="flex 2xl:gap-[40px] xl:gap-[40px] lg:gap-[40px] md:gap-[20px] gap-[10px] text-sm font-medium text-center mt-[50px]"
                    role="tablist"
                  >
                    {['About', 'Investment Requirements', 'Training Details', 'Other Details'].map((tab) => (
                      <li key={tab} className="me-2" role="presentation">
                        <button
                          className={`inline-block p-[5px] text-[#5D6C72] border-b-2 rounded-t-lg text-[14px] sm:text-[16px]  ${activeTab === tab
                            ? 'text-secondaryColor border-secondaryColor dark:text-secondaryColor dark:border-secondaryColor'
                            : 'text-gray-500 border-transparent hover:text-gray-600 hover:border-secondaryColor dark:text-gray-400 dark:hover:text-gray-300'
                            }`}
                          type="button"
                          onClick={() => handleTabChange(tab)}
                        >
                          {tab.charAt(0).toUpperCase() + tab.slice(1)} {/* Capitalize tab name */}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* Tab Content */}
                <div id="default-styled-tab-content" className=" w-[100%]">
                  <TabPanel activeTab={activeTab} tab="About">
                    <div className="bg-[#FAFAFA] p-[20px] rounded-[10px] sm:p-[50px]">
                      <div>
                        <p className="text-[#222222] text-[24px] font-medium mb-[10px]">
                          About
                        </p>
                      </div>
                      <div className="h-[200px] overflow-auto">
                        <p className="text-[#5D6C72] text-[16px]">
                          {parse(item?.business_overview)}
                        </p>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel activeTab={activeTab} tab="Investment Requirements">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {/* <div className="overflow-x-auto bg-card_bg_color rounded-lg border"> */}
                      <table className="w-full">
                        <tbody>

                          <tr className="align-baseline">
                            <td className="  px-2 py-2 font-sm w-[50%]">Franchise Tagline</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.franchise_tagline}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%] ">Franchise Fee</td>
                            <td className=" px-2 py-2 font-bold w-[40%] ">{item?.franchise_fees}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">Equipments</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.equipments}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Furniture And Fixtures
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">NO</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Advertising / Marketing
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">
                              {item?.advertising_marketing}
                            </td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Expected Pay Back Period
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">
                              {item?.expected_pay_back_period}
                            </td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              The Expected Return On Investment To The Franchisee
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">
                              {item?.return_on_investment}
                            </td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Any Other Investment Needed
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">No</td>
                          </tr>

                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">Master Franchise</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.master_franchise}</td>
                          </tr>
                        </tbody>
                      </table>
                      {/* </div> */}
                    </p>
                  </TabPanel>

                  <TabPanel activeTab={activeTab} tab="Training Details">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      <table className="min-w-full mt-3">
                        <tbody>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Field Assistance Available For Franchisees
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.field_assistance}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Franchise Traning programme
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">
                              {item?.training_programme}
                            </td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Detailed Operating Manuals For Franchisees
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">
                              {item?.detailed_operating}
                            </td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Need of IT System
                            </td>
                            <td className=" px-2 py-2 font-bold">{item?.it_system}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Assistance From Head Office To Franchisee
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.field_assistance}</td>
                          </tr>
                        </tbody>
                      </table>
                    </p>
                  </TabPanel>

                  <TabPanel activeTab={activeTab} tab="Other Details">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      <table className="min-w-full  mt-3">
                        <tbody>
                          <tr className="align-baseline">
                            <td className="  px-2 py-2 font-sm w-[50%]">Email</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.email}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">
                              Looking Expansion In Areas
                            </td>
                            <td className=" px-2 py-2 font-bold w-[40%]">Pan India</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">Website</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.website}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">State</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.state}</td>
                          </tr>
                          <tr className="align-baseline">
                            <td className=" px-2 py-2 font-sm w-[50%]">Franchise Term</td>
                            <td className=" px-2 py-2 font-bold w-[40%]">{item?.franchise_term}</td>
                          </tr>
                        </tbody>
                      </table>
                    </p>
                  </TabPanel>
                </div>
              </div>
              {/* form */}
              <div className="2xl:w-[30%] xl:w-[30%] lg:w-[30%] md:w-[30%] w-[100%]">
                <form
                  className="max-w-md mx-auto p-4 bg-card_bg_color rounded-md"
                  onSubmit={handleSubmit}
                >
                  <h2 className="mb-4 font-semibold">Apply for startup</h2>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Name <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="w-full p-2 border border-gray-300 rounded mt-1 "
                      value={formData.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.name && <ErrorMessage error={errors.name} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Email <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && <ErrorMessage error={errors.email} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Enter phone Number{" "}
                      <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="number"
                      name="phone"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.phone && <ErrorMessage error={errors.phone} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Select Country <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="country"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.country}
                      onChange={handleCountryChange}
                      onBlur={handleBlur}
                    >
                      <option value="">
                        Select country <span className="text-star_color">*</span>
                      </option>
                      {countries?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.country && <ErrorMessage error={errors.country} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Select State <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="state"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.state}
                      onChange={handleStateChange}
                      onBlur={handleBlur}
                    >
                      <option value="">
                        Select State <span className="text-star_color">*</span>
                      </option>
                      {statedata?.map((item) => (
                        <option value={item.name} data-id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {errors.state && <ErrorMessage error={errors.state} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Select City <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="city"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.city}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select City</option>
                      {citydata?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.city && <ErrorMessage error={errors.city} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Pincode <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      name="pincode"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.pincode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.pincode && <ErrorMessage error={errors.pincode} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Address <span className="text-star_color">*</span>
                    </label>
                    <textarea
                      name="address"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.address && <ErrorMessage error={errors.address} />}
                  </div>
                  <div className="mb-4">
                    <label className="block font-semibold">
                      Select Investment Range{" "}
                      <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="investment"
                      className="w-full p-2 border border-gray-300 rounded mt-1 "
                      value={formData.investment}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Investment Range</option>
                      {INVESTMENT_RANGE.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>
                    {errors.investment && (
                      <ErrorMessage error={errors.investment} />
                    )}
                  </div>
                  <div className="mb-4">
                    <p className="block font-semibold">Loan for Business</p>
                    <label className="inline-flex items-center mr-4">
                      <input
                        type="radio"
                        name="loan"
                        value="yes"
                        className="form-radio"
                        checked={formData.loan === "yes"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="loan"
                        value="no"
                        className="form-radio"
                        checked={formData.loan === "no"}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                      <span className="ml-2">No</span>
                    </label>
                    {errors.loan && <ErrorMessage error={errors.loan} />}
                  </div>
                  <div className="mb-4">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="terms_conditions"
                        className="form-checkbox "
                        checked={formData.terms_conditions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <span className="ml-2 text-gray-700">
                        I terms_conditions   to the Terms & Conditions
                      </span>
                    </label>
                    {errors.terms_conditions && <ErrorMessage error={errors.terms_conditions} />}
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="w-full bg-primaryColor p-2 rounded button button4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Recentsection data={recentData} />
      </div>
    </>
  );
}

export default Automotivedetails;
